<script setup lang="ts">
defineProps({
  error: Object
});

const route = useRoute();

// Determine if this is an LMS route
const isLmsRoute = computed(() => {
  return route.path.startsWith('/lms');
});
</script>

<template>
  <!-- LMS 404 Page - Uses LMS layout with full navigation -->
  <NuxtLayout v-if="isLmsRoute" name="lms">
    <div class="container mx-auto px-4 py-16">
      <div class="mx-auto max-w-2xl text-center">
        <h1 class="mb-4 text-6xl font-bold text-gray-800">404</h1>
        <h2 class="mb-6 text-3xl font-semibold text-gray-700">Page not found</h2>
        <p class="text-xl text-gray-600">
          Sorry, we couldn't find <span class="font-mono text-brand-title">{{ route.path }}</span>
        </p>
        <p class="mt-4 text-lg text-gray-500">
          Use the navigation menu above to explore our courses and content.
        </p>
      </div>
    </div>
  </NuxtLayout>

  <!-- Website 404 Page - Uses website layout with navigation -->
  <NuxtLayout v-else name="website">
    <div class="container mx-auto flex min-h-screen items-center justify-center px-4 py-12">
      <div class="max-w-2xl text-center">
        <h1 class="mb-4 text-6xl font-bold text-gray-800">404</h1>
        <h2 class="mb-6 text-3xl font-semibold text-gray-700">Page not found</h2>
        <p class="mb-4 text-xl text-gray-600">
          Sorry, we couldn't find this page.
        </p>
        <p class="text-lg text-gray-500">
          Use the navigation menu above to explore our site.
        </p>
      </div>
    </div>
  </NuxtLayout>
</template>
